import { lazyDefault, lazyNamed, prefetchImport } from './lazy-page';

// --- Importers (also used for hover / gate prefetch) ---

export const loadUserDetailPage = () => import('../pages/admin/user-detail-page');
export const loadMemberFunnelPage = () => import('../pages/admin/member-funnel-page');
export const loadAdminPage = () => import('../pages/admin/admin-page');
export const loadSampleCollectionsPage = () => import('../pages/admin/sample-collections-page');
export const loadInvitePage = () => import('../pages/admin/invite-page');
export const loadSurveyManagementPage = () => import('../pages/admin/survey-management-page');
export const loadLighthousePage = () => import('../pages/admin/lighthouse-page');
export const loadLighthouseNotesPage = () => import('../pages/admin/lighthouse-notes-page');
export const loadLighthouseNoteFormPage = () => import('../pages/admin/lighthouse-note-form-page');
export const loadDesignSystemPage = () => import('../pages/admin/design-system-page');
export const loadPrescreenManagerPage = () => import('../pages/admin/prescreen-manager');
export const loadFormManagerPage = () => import('../pages/admin/form-manager-page');
export const loadSecurityPage = () => import('../pages/admin/security-page');
export const loadOrgManagementPage = () => import('../pages/admin/org-management-page');
export const loadRecordsPage = () => import('../pages/admin/records-page');
export const loadPipelineDashboardPage = () => import('../pages/admin/pipeline-dashboard-page');
export const loadCohortsPage = () => import('../pages/admin/cohorts-page');
export const loadCohortChatPage = () => import('../pages/admin/cohort-chat-page');
export const loadOmicsLabPage = () => import('../pages/admin/omics-lab-page');
export const loadLLMJobsPage = () => import('../pages/admin/llm-jobs-page');
export const loadLLMJobExecution = () => import('../pages/admin/llm-job-execution');
export const loadLLMJobExecutionsList = () => import('../pages/admin/llm-job-executions-list');
export const loadLLMWorkflowExecutions = () => import('../pages/admin/llm-workflow-executions');
export const loadTeamManagementPage = () => import('../pages/customer/TeamManagementPage');
export const loadPhlebProviderDashboardPage = () => import('../pages/phleb/PhlebProviderDashboardPage');
export const loadInviteRedemptionPage = () => import('../pages/invite-redemption-page');
export const loadCountersignPage = () => import('../pages/countersign-page');
export const loadMcpOAuthCallbackPage = () => import('../pages/mcp-oauth-callback-page');
export const loadCscDashboardPage = () => import('../pages/clinic/CscDashboardPage');
export const loadApplicationRunnerPage = () => import('../pages/clinic/ApplicationRunnerPage');
export const loadPhlebDashboardPage = () => import('../pages/clinic/PhlebDashboardPage');

// --- Lazy route components ---

export const UserDetailPage = lazyNamed(loadUserDetailPage, 'UserDetailPage');
export const MemberFunnelPage = lazyNamed(loadMemberFunnelPage, 'MemberFunnelPage');
export const AdminPage = lazyNamed(loadAdminPage, 'AdminPage');
export const SampleCollectionsPage = lazyNamed(loadSampleCollectionsPage, 'SampleCollectionsPage');
export const InvitePage = lazyNamed(loadInvitePage, 'InvitePage');
export const SurveyManagementPage = lazyNamed(loadSurveyManagementPage, 'SurveyManagementPage');
export const LighthousePage = lazyNamed(loadLighthousePage, 'LighthousePage');
export const InviteRedirect = lazyNamed(loadLighthousePage, 'InviteRedirect');
export const LighthouseNotesPage = lazyNamed(loadLighthouseNotesPage, 'LighthouseNotesPage');
export const LighthouseNoteCreatePage = lazyNamed(loadLighthouseNoteFormPage, 'LighthouseNoteCreatePage');
export const LighthouseNoteViewPage = lazyNamed(loadLighthouseNoteFormPage, 'LighthouseNoteViewPage');
export const DesignSystemPage = lazyDefault(loadDesignSystemPage);
export const PrescreenManagerPage = lazyNamed(loadPrescreenManagerPage, 'PrescreenManagerPage');
export const FormManagerPage = lazyNamed(loadFormManagerPage, 'FormManagerPage');
export const SecurityPage = lazyNamed(loadSecurityPage, 'SecurityPage');
export const OrgManagementPage = lazyNamed(loadOrgManagementPage, 'OrgManagementPage');
export const RecordsPage = lazyNamed(loadRecordsPage, 'RecordsPage');
export const PipelineDashboardPage = lazyDefault(loadPipelineDashboardPage);
export const CohortsPage = lazyDefault(loadCohortsPage);
export const CohortChatPage = lazyDefault(loadCohortChatPage);
export const OmicsLabPage = lazyDefault(loadOmicsLabPage);
export const LLMJobsPage = lazyDefault(loadLLMJobsPage);
export const LLMJobExecution = lazyDefault(loadLLMJobExecution);
export const LLMJobExecutionsList = lazyDefault(loadLLMJobExecutionsList);
export const LLMWorkflowExecutions = lazyDefault(loadLLMWorkflowExecutions);
export const TeamManagementPage = lazyNamed(loadTeamManagementPage, 'TeamManagementPage');
export const PhlebProviderDashboardPage = lazyNamed(loadPhlebProviderDashboardPage, 'PhlebProviderDashboardPage');
export const InviteRedemptionPage = lazyNamed(loadInviteRedemptionPage, 'InviteRedemptionPage');
export const CountersignPage = lazyNamed(loadCountersignPage, 'CountersignPage');
export const McpOAuthCallbackPage = lazyDefault(loadMcpOAuthCallbackPage);
export const CscDashboardPage = lazyNamed(loadCscDashboardPage, 'CscDashboardPage');
export const ApplicationRunnerPage = lazyNamed(loadApplicationRunnerPage, 'ApplicationRunnerPage');
export const PhlebDashboardPage = lazyNamed(loadPhlebDashboardPage, 'PhlebDashboardPage');

export const prefetchUserDetailPage = () => prefetchImport(loadUserDetailPage);
